module.exports = __webpack_public_path__ + "img/facilityInfo_0_1.5a2537c0.jpg";